// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__gETeH","slideUp":"Auth_slideUp__O9uVi"};